<template>
  <print246 v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'disaster', label: '재해형태' },
      ]"
      :board="this.board"
      :is-print="isPrint"
      :multiple-disaster="true"
    />

    <!--    작업구분-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업구분</h5>

      <div class="gap-x-6 gap-y-4" :class="{ 'grid grid-cols-12 mt-4': !isMobile }">
        <div class="col-span-3 flex items-center" style="align-self: flex-start; word-break: keep-all" v-for="(checkbox, checkbox_i) in form.inspectionList" :key="`check_${checkbox_i}`">
          <div v-if="isPrint || board.readonly" class="flex">
            <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            {{ checkbox.title }}
          </div>
          <label v-else class="flex" :class="{ 'mt-1' : isMobile}">
            <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
            {{ checkbox.title }}
          </label>
        </div>
      </div>
    </div>

    <!-- 장비 정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 장비 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>장비 업체명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div>
          <div>장비 운전원</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" />
        </div>

        <div>
          <div>장비 종류(기종 및 모델명)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>
        <div>
          <div>장비 형식 및 규격(정격하종)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_5" />
        </div>
        <div>
          <div>작업지휘자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_7" />
        </div>
        <div>
          <div>작업유도자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_8 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_8" />
        </div>
      </div>
    </div>

    <!-- 목록표 -->
    <div v-for="(inspection, indexRows) in form.inspectionList" :key="indexRows" v-show="inspection.check">
      <TableInspectMerge
        v-for="(list, list_i) in inspection.typeLists"
        :key="`${indexRows}_${list_i}`"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :title="list.title"
        :tableHeaderTitle="list.type === 'note' ? '점검사항' : [{ text: '구분', width: 50, style: 'justify-content: center' }, { text: !!list.headerTitle ? list.headerTitle : '작업계획서 내용' }]"
        :tableHeaderCheck="list.type === 'note' ? [{ text: '양호' }, { text: '미흡' }, { text: 'N/A' }] : [{ text: '작성' }, { text: '미작성' }, { text: 'N/A' }]"
        :isNote="list.type === 'note'"
        :tableHeaderNote="[{ text: '비고' }]"
        v-model="list.data"
        :class="list.noMargin ? '-mt-px' : 'mt-28px'"
      />
    </div>

    <!-- 확인자 -->
    <div>
      <div class="mt-4">
        <h5><i class="dot"></i> 확인자</h5>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>안전관리자</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>관리책임자</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" title="작업 계획도 및 관련 도면 첨부"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import TableInspectDivision from "@/components/TableInspectDivision";
import Print246 from "@/views/boards/single-page/246/Print.vue";
import SignField from "@/components/SignField.vue";
import { required } from "vuelidate/lib/validators";
import { InspectData } from "./InspectData";

export default {
  components: {
    SignField,
    Print246,
    TableInspectDivision,
    TableInspectMerge,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {},
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = this.form.inspectionList.filter((li) => li.check).map((il) => il.title);
    },
    validate() {},
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  data() {
    return {
      isMobile: false,

      form: {
        stdInfo: {},
        inspectionList: JSON.parse(JSON.stringify(InspectData.filter(
          // [신규] SHM 시스템 URL 생성 및 메뉴 구성 : #86ep5bb9n 요청으로 제외
          (data) => data.title !== '타워크레인을 설치·조립·해체하는 작업' && data.title !== '차량계 건설기계를 사용하는 작업'
        ))),
        typeTitleList: [],

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        fileList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
